import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getPortfolioCompanies, getPortfolioCompany, createPortfolioCompany, updatePortfolioCompany } from '@lingaai/supabase-client';
import type { PortfolioCompany } from '@lingaai/types';

export function usePortfolioCompanies(fundId?: string) {
  return useQuery({
    queryKey: ['portfolioCompanies', fundId],
    queryFn: () => getPortfolioCompanies(fundId),
  });
}

export function usePortfolioCompany(companyId: string) {
  return useQuery({
    queryKey: ['portfolioCompanies', companyId],
    queryFn: () => getPortfolioCompany(companyId),
    enabled: !!companyId,
  });
}

export function useCreatePortfolioCompany() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: { tenant_id: string; fund_id: string; name: string; website?: string | null; sector?: string | null; external_id?: string | null; investment_date?: string | null }) =>
      createPortfolioCompany(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['portfolioCompanies'] });
    },
  });
}

export function useUpdatePortfolioCompany() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { companyId: string; updates: Partial<PortfolioCompany> }) => updatePortfolioCompany(variables.companyId, variables.updates),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['portfolioCompanies'] });
      queryClient.invalidateQueries({ queryKey: ['portfolioCompanies', variables.companyId] });
    },
  });
}
